<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <!-- <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" @datachange="getList" v-model="searchParam.plantCd" />
        </div> -->
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :editable="editable"
            type="search"
            :comboItems="useFlagItems"
            itemText="codeName"
            itemValue="code"
            label="사용여부"
            name="useFlag"
            v-model="searchParam.useFlag"
            @datachange="getList"
            >
          </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <c-tree-table
          title="폴더 목록"
          parentProperty="koshaParentFolderId"
          customID="koshaFolderId"
          :columns="gridFolder.columns"
          :data="gridFolder.data"
          :columnSetting="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="rowClick"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="등록" icon="add" @btnClicked="openPop" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template>
              <q-chip
                v-if="col.name==='rowFolder'"
                color="amber"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click.stop="() => openPop(props.row, 'ROWNEW')">
                ▼New
              </q-chip>
              <q-chip
                v-if="col.name==='editFolder'"
                color="blue"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click.stop="chipClick(props.row, col, props.pageIndex)">
                Edit
              </q-chip>
              <q-chip
                v-if="col.name==='openFolder'"
                color="green"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click.stop="rowClick(props.row)">
                Open▶
              </q-chip>
            </template>
          </template>
        </c-tree-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <c-table
          title="KOSHA 목록"
          rowKey="id"
          :columns="gridProcedure.columns"
          :data="gridProcedure.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <template slot="table-chip">
            <q-btn-group outline >
              <q-chip>
                  <q-avatar icon="bookmark" color="green" text-color="white" /> 
                  {{ "폴더명 : " + folderName}}
              </q-chip>
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props }">
            <template>
              <q-chip
                v-if="Boolean(props.row.folderLink)"
                color="amber"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click.stop="() => openLink(props.row)">
                바로가기
              </q-chip>
            </template>
          </template>
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="folderName" label="등록" icon="add" @btnClicked="procedureAdd" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'kosha',
  data() {
    return {
      gridFolder: {
        columns: [
          {
            name: 'folderName',
            field: 'folderName',
            label: '폴더명',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'rowFolder',
            field: 'rowFolder',
            label: '하위폴더생성',
            align: 'center',
            style: 'width:80px',
            type: 'custom',
            sortable: false
          },
          {
            name: 'editFolder',
            field: 'editFolder',
            label: '폴더수정',
            align: 'center',
            style: 'width:70px',
            type: 'custom',
            sortable: false
          },
          {
            name: 'openFolder',
            field: 'openFolder',
            label: '폴더열기',
            align: 'center',
            style: 'width:70px',
            type: 'custom',
            sortable: false
          },
        ],
        data: [],
        height: '362px'
      },
      gridProcedure: {
        columns: [
          // {
          //   name: 'plantName',
          //   field: 'plantName',
          //   label: '사업장',
          //   align: 'center',
          //   style: 'width:80px',
          //   sortable: false,
          // },
          {
            name: 'folderDetailName',
            field: 'folderDetailName',
            label: 'KOSHA명',
            type: "link",
            align: 'left',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'folderLink',
            field: 'folderLink',
            label: 'KOSHA링크',
            align: 'center',
            type: 'custom',
            style: 'width:100px',
            sortable: false,
          },
          // {
          //   name: 'file',
          //   field: 'file',
          //   label: '파일첨부',
          //   type: 'custom',
          //   align: 'center',
          //   style: 'width:100px',
          //   sortable: false,
          // },
        ],
        data: [],
        height: '362px'
      },
      searchParam: {
        useFlag: 'Y',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      editable: true,
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      searchUrl: '',
      folderName: '',
      koshaFolderId: ''
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.kosha.folder.list.url;
      this.listDetailUrl = selectConfig.kosha.folderDetail.list.url;

      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.gridFolder.data = _result.data;
        this.gridProcedure.data = []
      },)
    },
    /* eslint-disable no-unused-vars */
    rowClick(row) {
      this.koshaFolderId = row.koshaFolderId;
      this.folderName = row.folderName;
      this.$http.url = this.$format(this.listDetailUrl, row.koshaFolderId);
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.gridProcedure.data = _result.data
      },)
    },
    chipClick(row, col, index) {
      if (!row) return;
      this.openPop(row, 'DETAIL');
    },
    openPop(data, type) {
      let param = {};
      if (type === 'ROWNEW') {
        param = {
          koshaFolderId: '',
          koshaParentFolderId: data.koshaFolderId,
        }
      } else if (type === 'DETAIL') {
        param = {
          koshaFolderId: data.koshaFolderId,
        }
      } else {
        param = {
          koshaFolderId: '',
        }
      }
      this.popupOptions.title = '폴더 등록'; // KOSHA 가이드 폴더 등록
      this.popupOptions.param = param
      this.popupOptions.target = () => import(`${'./koshaFolder.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    openLink(row) {
      window.open(row.folderLink)
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    procedureAdd() {
      this.linkClick(null);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "KOSHA 가이드 상세"; // 지침서 상세
      this.popupOptions.param = {
        koshaFolderDetailId: row ? row.koshaFolderDetailId : '' ,
        koshaFolderId: this.koshaFolderId ? this.koshaFolderId : '' ,
      };
      this.popupOptions.target = () =>
        import(`${"./koshaDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '60%';
      this.popupOptions.closeCallback = this.closeDetailPopup;
    },  
    closeDetailPopup() {
        
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.rowClick({ koshaFolderId: this.koshaFolderId, folderName: this.folderName})
    }
  }
};
</script>
